import * as React from "react";
import { Spinner } from 'reactstrap';

const LoadingIndicator = () => {

    return (
        <div className="text-center">            
             <Spinner color="primary" />            
        </div>
    )
}

export default LoadingIndicator;